/**
 * Dev-only logger.
 *
 * In production builds (NODE_ENV === "production") all calls are no-ops,
 * so debug/warn/info messages are stripped by webpack/CRA dead-code
 * elimination and never reach the browser console.
 *
 * In development they surface in the console with a domain prefix so
 * we can debug storage / context / network paths without leaking
 * information in production.
 *
 * Replace with Sentry / LogRocket once Phase 2 backend is online.
 */
const IS_PROD = process.env.NODE_ENV === "production";

const noop = () => {};

export const logger = IS_PROD
  ? { warn: noop, info: noop, debug: noop, error: noop }
  : {
      warn: (...args) => console.warn(...args),
      info: (...args) => console.info(...args),
      debug: (...args) => console.debug(...args),
      // Errors in dev: keep them visible. In prod they go to Sentry (Phase 2).
      error: (...args) => console.error(...args),
    };
